import { t } from "../../i18n";
import { CheckCircle2, ChevronRight } from "lucide-react";
import { Card } from "./WorkspaceResultCard";
import { Heading } from "./WorkspaceResultHeading";
import { PathLabel } from "./WorkspaceResultPathLabel";
import { payload, recordValue, text } from "./WorkspaceResult.utils";

export function EditResult({
  name,
  input,
  result,
}: {
  name: string;
  input: Record<string, unknown>;
  result: unknown;
}) {
  const raw = recordValue(payload(result));
  const path =
    text(raw.path) ||
    text(raw.resolvedPath) ||
    text(input.path) ||
    t("Workspace file");
  const patch = name === "workspace_patch";
  const oldText = text(input.oldText);
  const newText = text(input.newText);
  const content = text(input.content);
  return (
    <Card tone="emerald">
      <Heading
        icon={
          <CheckCircle2
            size={16}
            className="text-emerald-700 dark:text-emerald-300"
          />
        }
      >
        {patch ? t("File updated") : t("File written")}
      </Heading>
      <PathLabel path={path} />
      {typeof raw.bytes === "number" && (
        <p className="mt-2 text-xs text-stone-500">
          {t("{{count}} bytes written", { count: raw.bytes })}
        </p>
      )}
      {(patch ? oldText || newText : content) && (
        <details className="group mt-3 overflow-hidden rounded-xl border border-emerald-200 bg-white/70 dark:border-emerald-900/60 dark:bg-black/10">
          <summary className="flex cursor-pointer list-none items-center gap-2 px-3 py-2 text-xs font-semibold marker:content-none">
            <ChevronRight
              size={14}
              className="transition-transform group-open:rotate-90"
            />
            {patch ? t("View change") : t("Preview file")}
          </summary>
          <pre className="max-h-64 overflow-auto border-t border-emerald-200 p-3 font-mono text-[11px] leading-5 whitespace-pre-wrap dark:border-emerald-900/60">
            {patch
              ? `${oldText ? `- ${oldText}\n` : ""}${newText ? `+ ${newText}` : ""}`
              : content}
          </pre>
        </details>
      )}
    </Card>
  );
}
